// src/components/LeadDetailModal.jsx
import React, { useState, useEffect } from 'react';
import { LeadIntake } from '../services/api';

const SOURCE_ICONS = {
    meta:'📘', google:'🔍', indiamart:'🏭',
    tradeindia:'🤝', justdial:'📞', manual:'📋', custom:'🔗',
};

export default function LeadDetailModal({ lead, onClose, onConvert, onJunk }) {
    const [detail,    setDetail]    = useState(null);
    const [busy,      setBusy]      = useState(true);
    const [showRaw,   setShowRaw]   = useState(false);

    useEffect(() => {
        LeadIntake.detail(lead.id)
            .then(setDetail)
            .finally(() => setBusy(false));
    }, [lead.id]);

    const d = detail || lead;

    const Row = ({ label, value }) => value ? (
        <div style={{ display:'flex', gap:'.75rem', padding:'7px 0',
            borderBottom:'1px solid var(--border,#f1f5f9)' }}>
            <div style={{ width:130, fontSize:'.75rem', fontWeight:600,
                textTransform:'uppercase', letterSpacing:'.05em',
                color:'var(--muted)', flexShrink:0 }}>{label}</div>
            <div style={{ fontSize:'.875rem', color:'var(--text)', wordBreak:'break-word' }}>{value}</div>
        </div>
    ) : null;

    return (
        <div style={{
            position:'fixed', inset:0, background:'rgba(0,0,0,.6)',
            display:'flex', alignItems:'center', justifyContent:'center',
            zIndex:2000, padding:'1rem',
        }}>
            <div style={{
                background:'var(--card-bg,#fff)', borderRadius:16,
                width:'100%', maxWidth:560,
                boxShadow:'0 25px 60px rgba(0,0,0,.35)',
                maxHeight:'90vh', display:'flex', flexDirection:'column',
            }}>
                {/* Header */}
                <div style={{
                    padding:'1rem 1.25rem',
                    borderBottom:'1px solid var(--border,#e2e8f0)',
                    display:'flex', justifyContent:'space-between', alignItems:'center',
                    background:'var(--bg,#f8fafc)', borderRadius:'16px 16px 0 0',
                }}>
                    <div style={{ display:'flex', alignItems:'center', gap:'.6rem' }}>
                        <span style={{ fontSize:'1.4rem' }}>
                            {SOURCE_ICONS[d.source_slug] || '📌'}
                        </span>
                        <div>
                            <div style={{ fontWeight:700, fontSize:'1rem' }}>
                                {d.full_name || 'Unknown Lead'}
                            </div>
                            <div style={{ fontSize:'.75rem', color:'var(--muted)' }}>
                                {d.source_name} · #{d.id}
                                {d.source_lead_id && <> · Platform ID: {d.source_lead_id}</>}
                            </div>
                        </div>
                    </div>
                    <button onClick={onClose} style={{
                        background:'none', border:'none',
                        fontSize:'1.3rem', cursor:'pointer',
                        color:'var(--muted)', lineHeight:1,
                    }}>✕</button>
                </div>

                {/* Body */}
                <div style={{ padding:'1rem 1.25rem', overflowY:'auto', flex:1 }}>
                    {busy ? (
                        <div className="spinner-wrap"><div className="spinner" /></div>
                    ) : (
                        <>
                            <Row label="Full Name"        value={d.full_name} />
                            <Row label="Phone"            value={d.phone
                                ? <a href={`tel:${d.phone}`} style={{ color:'var(--accent)' }}>{d.phone}</a>
                                : null} />
                            <Row label="Email"            value={d.email
                                ? <a href={`mailto:${d.email}`} style={{ color:'var(--accent)' }}>{d.email}</a>
                                : null} />
                            <Row label="Company"          value={d.company} />
                            <Row label="City"             value={d.city} />
                            <Row label="Product Interest" value={d.product_interest} />
                            <Row label="Message"          value={d.message} />
                            <Row label="Received"         value={d.created_at} />
                            {d.status === 'converted' && (
                                <Row label="Converted"    value={`Customer #${d.customer_id} · ${d.converted_at}`} />
                            )}

                            {/* Raw payload toggle */}
                            {d.raw_payload && (
                                <div style={{ marginTop:'1rem' }}>
                                    <button
                                        onClick={() => setShowRaw(!showRaw)}
                                        style={{ background:'none', border:'none', cursor:'pointer',
                                            fontSize:'.78rem', color:'var(--muted)',
                                            textDecoration:'underline', padding:0 }}>
                                        {showRaw ? '▲ Hide' : '▼ Show'} raw payload
                                    </button>
                                    {showRaw && (
                                        <pre style={{
                                            marginTop:'.5rem', padding:'.75rem',
                                            background:'#0f172a', color:'#94a3b8',
                                            borderRadius:8, fontSize:'.72rem',
                                            overflowX:'auto', maxHeight:200,
                                            fontFamily:'monospace',
                                        }}>
                                            {JSON.stringify(d.raw_payload, null, 2)}
                                        </pre>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </div>

                {/* Footer actions */}
                {d.status === 'new' && (
                    <div style={{
                        padding:'.9rem 1.25rem',
                        borderTop:'1px solid var(--border,#e2e8f0)',
                        display:'flex', gap:'.6rem', justifyContent:'flex-end',
                        background:'var(--bg,#f8fafc)', borderRadius:'0 0 16px 16px',
                    }}>
                        <button className="btn btn-ghost btn-sm"
                            onClick={() => onJunk('duplicate')}>
                            Mark Duplicate
                        </button>
                        <button className="btn btn-ghost btn-sm"
                            onClick={() => onJunk('junk')}
                            style={{ color:'#dc2626' }}>
                            Mark Junk
                        </button>
                        <button className="btn btn-primary"
                            onClick={onConvert}>
                            ✓ Convert to Customer
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
